export default "/kiban/_next/static/images/share-647b5557b43f2d9684cf66538a84552e.png";